export interface RoleDto {
  id: string;
  name: string;
  description?: string | null;
  created_at: string;
  updated_at: string;
}

import { createAuthRequestInit } from '../utils/auth';
import { API_BASE } from '../config/api';

export async function getRoles(): Promise<RoleDto[]> {
  const res = await fetch(`${API_BASE}/roles`, createAuthRequestInit());
  if (!res.ok) throw new Error('Failed to fetch roles');
  const json = await res.json();
  return json.data.roles as RoleDto[];
}

export async function getRole(id: string): Promise<RoleDto> {
  const res = await fetch(`${API_BASE}/roles/${encodeURIComponent(id)}`, createAuthRequestInit());
  if (!res.ok) throw new Error('Failed to fetch role');
  const json = await res.json();
  return json.data.role as RoleDto;
}

export async function updateRole(id: string, payload: { name?: string; description?: string | null; }): Promise<RoleDto> {
  const res = await fetch(
    `${API_BASE}/roles/${encodeURIComponent(id)}`,
    createAuthRequestInit(
      {
        method: 'PUT',
        body: JSON.stringify(payload)
      },
      true
    )
  );
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || 'Failed to update role');
  }
  const json = await res.json();
  return json.data.role as RoleDto;
}

export async function createRole(payload: { name: string; description?: string | null; }): Promise<RoleDto> {
  const res = await fetch(
    `${API_BASE}/roles`,
    createAuthRequestInit(
      {
        method: 'POST',
        body: JSON.stringify(payload)
      },
      true
    )
  );
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || 'Failed to create role');
  }
  const json = await res.json();
  return json.data.role as RoleDto;
}

export interface RolePermissionDto {
  module: string;
  can_read: 0 | 1 | boolean;
  can_write: 0 | 1 | boolean;
}

export async function getRolePermissions(roleId: string): Promise<RolePermissionDto[]> {
  const res = await fetch(`${API_BASE}/roles/${encodeURIComponent(roleId)}/permissions`, createAuthRequestInit());
  if (!res.ok) throw new Error('Failed to fetch role permissions');
  const json = await res.json();
  return json.data.permissions as RolePermissionDto[];
}

export async function updateRolePermissions(roleId: string, permissions: RolePermissionDto[]): Promise<RolePermissionDto[]> {
  const res = await fetch(
    `${API_BASE}/roles/${encodeURIComponent(roleId)}/permissions`,
    createAuthRequestInit(
      {
        method: 'PUT',
        body: JSON.stringify({ permissions })
      },
      true
    )
  );
  if (!res.ok) {
    const txt = await res.text();
    throw new Error(txt || 'Failed to update role permissions');
  }
  const json = await res.json();
  return json.data.permissions as RolePermissionDto[];
}


